import {
  GET_DB_HEALTH_CHECK_FAILURE,
  GET_DB_HEALTH_CHECK_REQUEST,
  GET_DB_HEALTH_CHECK_SUCCESS,
} from "./ActionType";

const initialState = {
  dbHealthCheck: [],
  loading: false,
  error: null,
};

export const dbHealthCheckReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_DB_HEALTH_CHECK_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case GET_DB_HEALTH_CHECK_SUCCESS:
      return {
        ...state,
        dbHealthCheck: action.payload,
        loading: false,
        error: null,
      };
    case GET_DB_HEALTH_CHECK_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    default:
      return state;
  }
};
